import { Button, ButtonProps, Flex, Modal, Text } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { MetaStore } from '@/stores/local/shared/MetaStore';
import { ConfirmPopupStore } from '@/stores/local/sidebar/SidebarNoteStore/ConfirmPopupStore';

import s from './ConfirmPopup.module.scss';

type Props = {
  meta: MetaStore;
  store: ConfirmPopupStore;
  title?: string;
  description: string;
  confirmButtonProps?: ButtonProps;
  confirm?: string;
};

const ConfirmPopup: React.FC<Props> = ({
  meta,
  store,
  title = 'Удаление',
  description = 'Вы хотите удалить?',
  confirmButtonProps,
  confirm = ' Удалить',
}) => {
  return (
    <Modal
      centered
      title={
        <Text size="md" fw="400">
          {title}
        </Text>
      }
      opened={store.isOpen}
      onClose={store.close}
    >
      <Flex className={s.root} gap="md" direction="column">
        <Text size="sm" c="gray">
          {description}
        </Text>
      </Flex>
      <Flex gap="md" justify="flex-end" className={s.root__footer}>
        <Button size="sm" variant="transparent" onClick={store.close}>
          <Text size="sm" c="dark">
            Отменить
          </Text>
        </Button>
        <Button
          size="sm"
          variant="filled"
          color="red"
          {...confirmButtonProps}
          loading={meta.isLoading}
          onClick={store.confirm}
        >
          <Text size="sm">{confirm}</Text>
        </Button>
      </Flex>
    </Modal>
  );
};

export default observer(ConfirmPopup);
